module.exports = __webpack_public_path__ + "img/sba-certificate.7916f3ae.svg";